import { useState, useCallback } from 'react';

const useSmartFitDialog = () => {
  const [smartFitState, setSmartFitState] = useState(null);

  const openSmartFit = useCallback(
    ({ resourceRequest, resourceUser, allocationChartRef }) => {
      setSmartFitState({
        resourceRequest,
        resourceUser: { ...resourceUser, id: resourceUser.uri },
        allocationChartRef
      });
    },
    []
  );

  const closeSmartFit = useCallback(() => setSmartFitState(null), []);

  return {
    isSmartFitOpen: Boolean(smartFitState),
    smartFitState,
    openSmartFit,
    closeSmartFit
  };
};

export default useSmartFitDialog;
